import { useMediaQuery } from '@mui/material';
import ActivityTableBody from 'FeatureModules/Activity/Components/ActivitiesTable/ActivitiesTableBody';
import {
  EActivitiesTableColumnKeys,
  activitiesHeaderColumns,
} from 'FeatureModules/Activity/Components/ActivitiesTable/activitiesHeaderColumns';
import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable } from 'Components/TableBase/Table';
import React, { useMemo } from 'react';
import theme from 'styles/theme';
import { IActivity } from 'FeatureModules/Activity/types/activity.types';

interface IProps {
  columns: EActivitiesTableColumnKeys[];
  activities: IActivity[];
  hideHeader?: boolean;
  isTransparent?: boolean;
  onSelect: (activity: IActivity) => void;
  onEdit: (activity: IActivity) => void;
}

const ActivitiesTable: React.FC<IProps> = ({
  columns,
  activities,
  hideHeader = false,
  isTransparent = false,
  onSelect,
  onEdit,
}) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xl'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const shownColumns = useMemo(
    () =>
      activitiesHeaderColumns.filter(
        ({ id }) =>
          columns.includes(id) &&
          (isSmallScreen || isExtraSmallScreen
            ? id !== EActivitiesTableColumnKeys.MODIFIED_TIMESTAMP
            : true) &&
          (isExtraSmallScreen ? id !== EActivitiesTableColumnKeys.ACTIONS : true)
      ),
    [columns, isSmallScreen, isExtraSmallScreen]
  );

  return (
    <>
      <StyledTable
        aria-labelledby="tableTitle"
        aria-label="enhanced table"
        data-testid="partners-table"
      >
        {!hideHeader && <SortableTableHead headerColumns={shownColumns} />}
        <ActivityTableBody
          isTransparent={isTransparent}
          activities={activities}
          onSelect={onSelect}
          onEdit={onEdit}
          headerColumns={shownColumns}
        />
      </StyledTable>
    </>
  );
};

export default ActivitiesTable;
